const stringifyObject = (data) =>
  Object.entries(data)
    .filter(([key, value]) => value !== undefined)
    .map(([key, value]) => `${key}: ${value}`)
    .join(", ");

export default stringifyObject;
